import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { DialogService, PermissoesService } from 'app/services';

export const permissoesGuard: CanActivateFn = (route, state) => {
  const permissoesService = inject(PermissoesService);
  const router = inject(Router);
  const dialogService = inject(DialogService);

  const temPermissao = permissoesService.usuarioTemPermissao(route.data['permissao']);

  if (!temPermissao) {
    dialogService.erro('Ops...', 'Você não tem permissão de acessar essa página');
    router.navigate(['premoplan']);
  }

  return temPermissao;
};
